import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { GreetPopupComponent } from './greet-popup/greet-popup.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private _dialog: MatDialog) {
    // this._dialog.open(GreetPopupComponent, { backdropClass: 'greetBg', panelClass: 'greetPanel', maxWidth: 'unset' });
  }

  title = 'startupForm';
}
